<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
    import { Button } from '@oat-sa-private/ui-elements';

    export let message = '';
    export let buttonProps = {};

    const defaultButton = {
        size: 'small',
        shape: 'pill',
        iconSide: 'right'
    };

    buttonProps = { ...defaultButton, ...buttonProps };
</script>

<span class="ribbon-message">{message}</span>
<Button {...buttonProps} on:click />
